exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-generated-content[data-v-f9703520] img{max-width:100%;height:auto;border-radius:8px;margin:20px 0}.user-generated-content[data-v-f9703520] p{line-height:1.8;color:#555;margin-bottom:1.5rem}", ""]);

// exports
